// axiosInstance.js

import axios from 'axios';
import { BASE_URL, BASE_URL2, applyJwtAuth } from './axios';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});
const axiosInstance2 = axios.create({
  baseURL: BASE_URL2,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

axiosInstance.interceptors.request.use((config) => applyJwtAuth(config));
axiosInstance2.interceptors.request.use((config) => applyJwtAuth(config));

export  {axiosInstance
  ,axiosInstance2
};
